import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import styles from './deviceMode.module.scss'
import { $watched } from '../../../storeManager/Reducers/deviceSlice'

const DeviceMode = () => {
  var refElement
  const dispatch = useDispatch()
  const arrDevice = [
    { type: 'Desktop', id: 1 },
    { type: 'Laptop', id: 2 },
    { type: 'Tablet', id: 3 },
    { type: 'Mobile', id: 4 },
  ]
  useEffect(() => {
    if (refElement) {
      setModeDevice()
      window.addEventListener('resize', () => {
        setModeDevice()
      })
    }
  })
  const setModeDevice = () => {
    var currentDevice
    refElement.childNodes.forEach((item) => {
      var active = window.getComputedStyle(item).getPropertyValue('opacity')
      if (active === '1') {
        arrDevice.map((n) => {
          if (item.className.includes(n.type) && !currentDevice) {
            currentDevice = n
          }
        })
      }
    })
    dispatch($watched(currentDevice))
  }
  return (
    <>
      <div
        ref={(node) => {
          if (node) {
            refElement = node
          }
        }}
      >
        <div className={styles.Device__Desktop}></div>
        <div className={styles.Device__Laptop}></div>
        <div className={styles.Device__Mobile}></div>
        <div className={styles.Device__Tablet}></div>
      </div>
    </>
  )
}

export default DeviceMode
